module.exports = __webpack_public_path__ + "assets/benefits-card-6e4f25.svg";